const defaultStoreData = {
  activeStep: 0,
  statusSteps: [],
  data: {},
  query: {},
};
export default defaultStoreData;
